import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
let DataSelect = class DataSelect extends Vue {
    render(h) {
        return h("a-button", '选择文件');
    }
};
tslib_1.__decorate([
    Prop()
], DataSelect.prototype, "control", void 0);
DataSelect = tslib_1.__decorate([
    Component({ name: 'DataSelect' })
], DataSelect);
export default DataSelect;
